export default {"src":"/_next/static/media/icon_3dmodel_default.18834d95.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};